// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__2DdL2","errorLogs":"styles_errorLogs__1k0Dl"};